import { DataArray, IDataArray } from './../../shared/index';
import { PoweredBy, Classification, Project } from './../index';

export class Preset implements IDataArray {
    public Id = 0;
    public PresetName = '';
    public Selected = false;
    public documentsVisible = false;
    constructor() {

    }
    public GetById(): number {
        return this.Id;
    }
}
